/**
 * Display and error utilities for SmswiserCampaignStatsTab.
 * For Media Devoted | Created By Ciro Autiero
 */

const MAX_DISPLAY_LEN = 44;

export function toRangeISO(fromDate: string, toDate: string): { from: string; to: string } {
  return {
    from: `${fromDate}T00:00:00.000Z`,
    to: `${toDate}T23:59:59.999Z`,
  };
}

export function extractStatsErrorMessage(error: unknown): string {
  const maybe = error as {
    message?: string;
    response?: {
      data?: {
        message?: string | string[];
        error?: string | { code?: string; message?: string | string[] };
      };
    };
  };

  const data = maybe?.response?.data;
  const err = data?.error;

  let raw: string | undefined;
  if (typeof err === 'object' && err !== null && err.message !== undefined) {
    raw = Array.isArray(err.message) ? err.message[0] : String(err.message);
  } else if (typeof data?.message === 'string') {
    raw = data.message;
  } else if (Array.isArray(data?.message) && data.message.length > 0) {
    raw = String(data.message[0]);
  } else if (typeof maybe?.message === 'string') {
    raw = maybe.message;
  }

  if (raw) {
    const lower = raw.toLowerCase();
    if (lower.includes('wiserids') && (lower.includes('shorter') || lower.includes('200') || lower.includes('2000'))) {
      return 'This campaign group has too many campaigns. Remove some campaigns or split into smaller groups.';
    }
    if (
      lower.includes('traffic_campaign_id') ||
      lower.includes('same voluum_campaign_id') ||
      lower.includes('voluum_campaign_id')
    ) {
      return 'All campaigns in this group must share the same tracker campaign.';
    }
    if (
      lower.includes('no trafficcampaignid') ||
      lower.includes('trafficcampaignid') ||
      lower.includes('no voluumcampaignid') ||
      lower.includes('voluumcampaignid')
    ) {
      return 'No tracker campaign linked. Set a traffic link or run catalog refresh.';
    }
    return raw;
  }

  return 'Please try again.';
}

export function truncateEnd(text: string, maxLen = MAX_DISPLAY_LEN): { display: string; full: string } {
  const full = text.trim();
  if (!full || full.length <= maxLen) return { display: full || '—', full: full || '—' };
  return { display: `…${full.slice(-(maxLen - 1))}`, full };
}

/** Human-readable label for date range preset (e.g. "last-30-days" → "last 30 days"). */
export function formatDateRangePreset(preset: string): string {
  if (!preset) return preset;
  const kebab = preset.trim().toLowerCase();
  if (kebab === 'last-30-days') return 'last 30 days';
  if (kebab === 'last-7-days') return 'last 7 days';
  if (kebab === 'last-14-days') return 'last 14 days';
  if (kebab === 'last-3-days') return 'last 3 days';
  if (kebab === 'last-24-hours') return 'last 24 hours';
  if (kebab === 'last-48-hours') return 'last 48 hours';
  if (kebab === 'today') return 'today';
  if (kebab === 'yesterday') return 'yesterday';
  if (kebab === 'this-month') return 'this month';
  if (kebab === 'last-month') return 'last month';
  if (kebab === 'this-year') return 'this year';
  if (kebab === 'last-year') return 'last year';
  if (kebab === 'custom') return 'custom range';
  return preset.replace(/-/g, ' ');
}
